import Toast, { ToastBody } from '../../../../shared/Toast'

const CopyToClipboardToast = ({
	error = false,
}: {
	error?: boolean
}): JSX.Element => {
	if (error) {
		return (
			<Toast>
				<ToastBody>No track IDs found</ToastBody>
			</Toast>
		)
	}

	return (
		<Toast>
			<ToastBody data-testid="copy-to-clipboard-toast-message">
				Track IDs copied to clipboard.
			</ToastBody>
		</Toast>
	)
}

export default CopyToClipboardToast
